export default {
    // हेडर सेक्शन
    "birth_chart_generator": "जन्म कुंडली जनरेटर",
    "create_your": "अपनी बनाएं",
    "birth_chart": "जन्म कुंडली",
    "kundli_analysis": "और कुंडली विश्लेषण",
    "birth_chart_description": "अपनी सटीक जन्म जानकारी के आधार पर विस्तृत ग्रह स्थिति, भविष्यवाणियां और उपायों के साथ अपनी व्यक्तिगत वैदिक जन्म कुंडली तैयार करें।",

    // फॉर्म फ़ील्ड्स
    "enter_birth_details": "अपनी जन्म जानकारी दर्ज करें",
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "महिला",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "time_of_birth": "जन्म समय",
    "exact_time_note": "सटीक जन्म समय सही भविष्यवाणी के लिए आवश्यक है",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "place_birth_note": "सटीक गणना के लिए पूरा जन्म स्थान दर्ज करें",

    // चार्ट विकल्प
    "chart_type": "कुंडली प्रकार",
    "south_indian_style": "दक्षिण भारतीय शैली",
    "north_indian_style": "उत्तर भारतीय शैली",
    "east_indian_style": "पूर्वी भारतीय शैली",

    // क्रियाएं
    "generate_birth_chart": "जन्म कुंडली बनाएं",
    "generating_chart": "कुंडली बनाई जा रही है",
    "download_chart": "कुंडली डाउनलोड करें",
    "view_detailed_report": "विस्तृत रिपोर्ट देखें",

    // फीचर्स
    "what_you_get": "आपको क्या मिलेगा",
    "detailed_planetary_positions": "विस्तृत ग्रह स्थिति",
    "zodiac_sign_analysis": "राशि विश्लेषण",
    "dasha_system_predictions": "दशा प्रणाली भविष्यवाणी",
    "remedial_suggestions": "उपाय सुझाव",

    // विज़ुअल एलिमेंट्स
    "sample_birth_chart": "नमूना जन्म कुंडली",
    "sample_chart_description": "आपकी व्यक्तिगत जन्म कुंडली इस प्रकार दिखेगी",
    "astrological_elements": "ज्योतिषीय तत्व",

    // ग्रह
    "sun": "सूर्य",
    "moon": "चंद्रमा",
    "mars": "मंगल",
    "mercury": "बुध",
    "jupiter": "बृहस्पति",
    "venus": "शुक्र",

    // परिणाम
    "your_birth_chart": "आपकी जन्म कुंडली",
    "chart_generated_successfully": "कुंडली सफलतापूर्वक बनाई गई!",
    "chart_ready_message": "आपकी व्यक्तिगत जन्म कुंडली विस्तृत विश्लेषण और भविष्यवाणी के साथ तैयार है।"
}
